import React from 'react';
import { motion } from 'framer-motion';
import { Check, X } from 'lucide-react';
import { Link } from 'react-router-dom';
interface Feature {
  name: string;
  included: boolean;
}
interface PricingCardProps {
  title: string;
  price: string;
  subtitle?: string;
  description: string;
  features: (string | Feature)[];
  isPopular?: boolean;
  isLarge?: boolean;
  ctaText: string;
  ctaLink: string;
  badgeText?: string;
}
export function PricingCard({
  title,
  price,
  subtitle,
  description,
  features,
  isPopular = false,
  isLarge = false,
  ctaText,
  ctaLink,
  badgeText = 'MOST POPULAR'
}: PricingCardProps) {
  return <motion.div whileHover={{
    y: -8
  }} className={`relative flex flex-col h-full bg-dark-card rounded-xl border transition-colors duration-300 ${isPopular ? 'border-accent-gold' : 'border-dark-border hover:border-accent-blue'} p-6`} data-id="element-52">
      {isPopular && <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-accent-gold text-black font-heading tracking-wider px-4 py-1 rounded-full text-sm font-bold shadow-lg whitespace-nowrap" data-id="element-53">
          {badgeText}
        </div>}

      <div className="mb-6" data-id="element-54">
        <h3 className="text-2xl font-heading text-white mb-2" data-id="element-55">{title}</h3>
        <div className="flex flex-col mb-2" data-id="element-56">
          <span className="text-4xl font-heading text-white" data-id="element-57">{price}</span>
          {subtitle && <span className="text-gray-400 text-sm font-body mt-1" data-id="element-58">
              {subtitle}
            </span>}
        </div>
        <p className="text-gray-400 text-sm font-body" data-id="element-59">{description}</p>
      </div>

      <div className="flex-grow mb-8" data-id="element-60">
        <ul className="space-y-3" data-id="element-61">
          {features.map((feature, idx) => {
          const isObject = typeof feature === 'object';
          const name = isObject ? feature.name : feature;
          const included = isObject ? feature.included : true;
          return <li key={idx} className={`flex items-start gap-3 text-sm font-body ${included ? 'text-gray-300' : 'text-gray-600 line-through'}`} data-id="element-62">
                {included ? <Check className={`w-5 h-5 shrink-0 ${isPopular ? 'text-accent-gold' : 'text-accent-blue'}`} data-id="element-63" /> : <X className="w-5 h-5 shrink-0 text-gray-600" data-id="element-64" />}
                <span data-id="element-65">{name}</span>
              </li>;
        })}
        </ul>
      </div>

      {ctaLink.startsWith('http') ? <a href={ctaLink} target="_blank" rel="noopener noreferrer" className={`w-full py-3 px-4 rounded-lg font-heading tracking-wider text-center transition-all duration-300 ${isPopular ? 'bg-accent-gold text-black hover:bg-yellow-400' : 'bg-accent-blue text-black hover:bg-accent-blue-hover'}`} data-id="element-66">
          {ctaText}
        </a> : <Link to={ctaLink} className={`w-full py-3 px-4 rounded-lg font-heading tracking-wider text-center transition-all duration-300 ${isPopular ? 'bg-accent-gold text-black hover:bg-yellow-400' : 'bg-accent-blue text-black hover:bg-accent-blue-hover'}`} data-id="element-67">
          {ctaText}
        </Link>}
    </motion.div>;
}